module.exports = require("./fr-GP");